
// Initial values for gift card design
export const cardDesignInitialValuesForAll = [
  {
    x: 30,
    y: 30,
    xWithTextWidth: 30,
    shadowX: 2,
    shadowY: 2,
    show: false,
    fontSize: 16,
    alignment: 1,
    disclaimer: 0,
    shadowBlur: 4,
    content: "المهدي ",
    color: "#000000",
    hasShadow: false,
    borderThickness: 0,
    borderColor: "#000000",
    shadowColor: "#000000",
  },
  {
    x: 30,
    y: 30,
    xWithTextWidth: 30,
    shadowX: 2,
    shadowY: 2,
    show: false,
    fontSize: 16,
    alignment: 1,
    disclaimer: 1,
    shadowBlur: 4,
    content: "المهدي اليه",
    color: "#000000",
    hasShadow: false,
    borderThickness: 0,
    borderColor: "#000000",
    shadowColor: "#000000",
  },
  {
    x: 30,
    y: 30,
    xWithTextWidth: 30,
    shadowX: 2,
    shadowY: 2,
    show: false,
    fontSize: 16,
    alignment: 1,
    disclaimer: 2,
    shadowBlur: 4,
    content: "المشروع",
    color: "#000000",
    hasShadow: false,
    borderThickness: 0,
    borderColor: "#000000",
    shadowColor: "#000000",
  },
  {
    x: 40,
    y: 40,
    xWithTextWidth: 30,
    shadowX: 2,
    shadowY: 2,
    show: false,
    fontSize: 16,
    alignment: 1,
    disclaimer: 3,
    shadowBlur: 4,
    content: "الاسهم",
    color: "#000000",
    hasShadow: false,
    borderThickness: 0,
    borderColor: "#000000",
    shadowColor: "#000000",
  },
];

// Initial values for search
export const searchValues = {
  title: "",
  toDate: "",
  fromDate: "",
  toAmount: "",
  isActive: "",
  fromAmount: "",
  isArchived: "",
  isCompleted: "",
  showInHomePage: "",
};

// Table columns for attributes
export const attributesTableColumns = ["اسم الفئة", "المبلغ", "صورة الفئة"];

// Excel header cells mapping
export const excelHeaderCellsName = {
  "المعرف": "id",
  "صورة الاهداء": "imageFullUrl",
  "الاسم": "name",
  "المبلغ المطلوب": "requiredAmount",
  "المبلغ الإجمالي": "totalAmount",
  "عدد التبرعات": "donationCount",
  "نسبة التحقق": "progressPercentage",
  "نشط": "isActive",
  "مؤرشف": "isArchived",
};
